import { render, staticRenderFns } from "./equiposMovilesDigitales.vue?vue&type=template&id=89ff6518&scoped=true&"
import script from "./equiposMovilesDigitales.vue?vue&type=script&lang=js&"
export * from "./equiposMovilesDigitales.vue?vue&type=script&lang=js&"
import style0 from "./equiposMovilesDigitales.vue?vue&type=style&index=0&id=89ff6518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ff6518",
  null
  
)

export default component.exports